module.exports = __webpack_public_path__ + "static/media/user-cowboy.7f70547c.svg";